var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "grm-avatar-form-component", class: _vm.icon },
    [
      _c("div", { staticClass: "grm-avatar-form" }, [
        _c(
          "div",
          { staticClass: "grm-avatar-wrapper" },
          [
            _c(
              "lazy-component",
              { key: _vm.userProfileUrl, staticClass: "grm-avatar-lazy" },
              [
                _c("img", {
                  staticClass: "grm-avatar",
                  style: {
                    visibility: _vm.userProfileUrl ? "visible" : "hidden",
                  },
                  attrs: { src: _vm.userProfileUrl, alt: "profile" },
                  on: {
                    error: function ($event) {
                      _vm.userProfileUrl = ""
                    },
                  },
                }),
              ]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }